import React from 'react';
import { connect } from 'react-redux';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import {
  createIssueCategory,
  fetchAllCategories,
  patchIssueCategory,
} from '@sophocles/entities/IssueCategory/issueCategoryActions';
import {
  createIssueSubCategory,
  fetchAllIssuesForCreation,
  patchIssueSubCategory,
} from '@sophocles/entities/IssueSubCategory/issueSubCategoryActions';
import { getAuthUserSelector } from '@sophocles/features/auth/authSelectors';
import IssueCategoryList from '@sophocles/views/admin/management/issueCategories/IssueCategoryList';

class IssueCategoryPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  _setLoading = loading => this.setState({ loading });

  render() {
    const { customer } = this.props;
    const { loading } = this.state;
    const pageTitle = 'Issue Categories';
    return (
      <AppNav {...this.props} loading={loading} page="admin_home" notFullHeight={true}>
        <div className="container-fluid" style={{ top: '64px', height: '100%', margin: '0 16px' }}>
          <TitleBar showBackButton title={pageTitle} />
          <div className="row" style={{ height: 'calc(100% - 64px)' }}>
            <IssueCategoryList {...this.props} setLoading={this._setLoading} />
          </div>
        </div>
      </AppNav>
    );
  }
}

function mapStateToProps(state) {
  return { user: getAuthUserSelector(state) };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchSubCategories: () => dispatch(fetchAllIssuesForCreation()),
    fetchCategories: () => dispatch(fetchAllCategories()),
    patchIssue: (version_id, values) => dispatch(patchIssueSubCategory(version_id, values)),
    patchCategory: (version_id, values) => dispatch(patchIssueCategory(version_id, values)),
    createIssue: values => dispatch(createIssueSubCategory(values)),
    createCategory: values => dispatch(createIssueCategory(values)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueCategoryPage);
